var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[_c('v-main',[(!_vm.isNotFoundPage && _vm.$route.path !== '/inseeqr' && _vm.$route.path !== '/inseeQR')?_c('NavBar'):_vm._e(),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }